import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Row, Modal, Table, Form, InputGroup, FormControl } from 'react-bootstrap'
import NavSearch from '../layouts/AdminLayout/NavBar/NavLeft/NavSearch';
import { getServerURL } from '../helper/envConfig';
import api from '../helper/api';
import { errorResponse } from '../helper/error';
import { toast } from 'react-toastify';
import Loader from './Loader/Loader';
import PaginationC from './pagination';

const Faqs = (props) => {

    const serverURL = getServerURL()

    const modalOpen = () => {
        setModalShow(true)
    }

    const [modalShow, setModalShow] = useState(false);
    const [viewModalShow, setViewModalShow] = useState(false);
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [pageList, setPageList] = useState([])
    const [subLoader, setSubLoader] = useState(false)

    const [states, setStates] = useState({})
    const [validated, setValidated] = useState(false);
    const [data, setData] = useState([])
    const [viewData, setViewData] = useState([])
    const [deleteData, setDeleteData] = useState()
    const [loading, setLoading] = useState(true)
    const [mode, setMode] = useState()
    const [paginationData, setPaginationData] = useState({})
    const [page, setPage] = useState(1)

    useEffect(() => {
        getFAQSList();
    }, [searchText, page]);

    useEffect(() => {
        if (searchText?.length) setPage(1);
    }, [searchText]);

    useEffect(() => {
        getPageName();
    }, []);

    const getPageName = (event) => {
        api.getWithToken(`${serverURL}page/?is_faq_page_only=true`)
            .then(async (res) => {
                if (res?.data?.success === true) {
                    setPageList(res?.data?.data);
                }
            })
            .catch((e) => {
            });
    };

    const getFAQSList = (event) => {
        api.getWithToken(`${serverURL}page/faq/?page=${page}`)
            .then(async (res) => {
                setLoading(false)
                const { data, links, page, page_size, total, total_pages } = res?.data;
                setPaginationData({ links, page, page_size, total, total_pages })
                if (res?.data?.success === true) {
                    setData(res?.data?.data);
                }
            })
            .catch((e) => {
                setLoading(false)
            });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setStates((prevValues) => ({
            ...prevValues,
            [name]: value.trimStart(),
        }));
    };

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();

        if (form.checkValidity()) {
            setValidated(false);
            const type = Boolean(mode) ? "postWithToken" : "putWithToken";
            const formData = new FormData();
            formData.append("page", states?.page_slug);
            formData.append("question", states?.question);
            formData.append("answer", states?.answer);
            formData.append("index", states?.index);
            if (states?.id)
                formData.append("id", states?.id);

            setSubLoader(true)
            api[type](`${serverURL}page/faq/`, formData)
                .then(async (res) => {
                    setModalShow(false)
                    setStates({})
                    form.reset();
                    setLoading(false);
                    setSubLoader(false)
                    if (res?.data?.success === true) {
                        toast.success(res?.data?.message);
                        getFAQSList();
                    } else if (res?.data?.success === false) {
                        if (typeof res?.data?.message === "string")
                            toast.error(res?.data?.message);
                    }
                })
                .catch((e) => {
                    errorResponse(e);
                    setLoading(false);
                    setSubLoader(false)
                });
        } else {
            setValidated(true);
            setSubLoader(false)
            setLoading(false);
            event.stopPropagation();
        }
    };

    const deleteFAQ = () => {
        setSubLoader(true)
        api.deleteWithToken(`${serverURL}page/faq/${deleteData}`)
            .then(async (res) => {
                setDeleteModalShow(false)
                setSubLoader(false)
                if (res?.data?.success === true) {
                    toast.success(res?.data?.message);
                    getFAQSList()
                } else if (res?.data?.success === false) {
                    if (typeof res?.data?.message === "string")
                        toast.error(res?.data?.message);
                }
            })
            .catch((e) => {
                setSubLoader(false)
                errorResponse(e);
            });
    };

    return (
        <>
            <Card className="user-list">
                <Card.Header>
                    <div className='d-flex justify-content-between align-items-center'>
                        <Card.Title as="h4">{props?.title || ""}</Card.Title>
                        <div className='d-flex align-items-center'>
                            <header className="navbar pcoded-header" style={{ backgroundColor: "#fff" }}> <NavSearch searchText={searchText} setSearchText={setSearchText} /></header>
                            <Button variant={"outline-primary"} className='m-0' onClick={() => { setMode(true); modalOpen(), setStates({}) }}>
                                {"Add"}
                            </Button>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Table responsive hover className='product-table'>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Page</th>
                                <th>Question</th>
                                <th>Answer</th>
                                <th>Index</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Boolean(loading) ?
                                <tr>
                                    <td colSpan={6} className='text-center'>
                                        <Loader loading={loading} />
                                    </td>
                                </tr>
                                :
                                Boolean(data?.length) ? data?.map((item, index) =>
                                    <tr key={index + "faqList"} onClick={() => { setViewData(item); setViewModalShow(true) }}>
                                        <td>{(10 * (page - 1)) + (index + 1)}</td>
                                        <td>
                                            <h6 className="m-0">{item?.page} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.question} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.answer}</h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.index || "-"}</h6>
                                        </td>
                                        <td>
                                            <div className='d-flex align-items-center gap-3'>
                                                <div className='cursor-pointer' onClick={(e) => { setMode(false); setStates(item); modalOpen(); e.stopPropagation(); }}>
                                                    <i className="feather icon-edit" title='Edit' />
                                                </div>
                                                <div className='cursor-pointer' onClick={(e) => { setDeleteData(item?.id); setDeleteModalShow(true); e.stopPropagation(); }}>
                                                    <i className="feather icon-trash-2" title='Delete' />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )
                                    :
                                    <tr>
                                        <td colSpan={6} className='text-center'>
                                            There are no records available at the moment.
                                        </td>
                                    </tr>
                            }

                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {Boolean(data?.length) && paginationData?.total_pages > 1 &&
                <PaginationC data={paginationData}
                    onPageChange={(newPage) => {
                        setPage(newPage);
                    }} />}

            {/* add modal */}
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    {Boolean(subLoader) && <Loader loading={subLoader} />}
                    <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <Card.Title as="h5">{Boolean(mode) ? "Add " : "Edit "} {props?.title}</Card.Title>
                            <Modal.Header closeButton className='border-0'>
                            </Modal.Header>
                        </Card.Header>
                        <Card.Body>
                            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                <Form.Group className="mb-4" as={Row} controlId="formHorizontalName">
                                    <Form.Label column sm={3}>
                                        Page Name
                                    </Form.Label>
                                    <Col sm={9}>
                                        <InputGroup>
                                            <FormControl as="select" aria-describedby="custom-addons1" className="custom-select" value={states?.page_slug || ""} name='page_slug' onChange={handleChange} required>
                                                <option value={""} disabled>Select page name</option>
                                                {Boolean(pageList?.length) &&
                                                    pageList?.map((item, index) => <option key={index + "pageList"} value={item?.slug} className='text-capitalize'>{item?.name}</option>)}
                                            </FormControl>
                                            <Form.Control.Feedback type="invalid">Please select page.</Form.Control.Feedback>
                                        </InputGroup>
                                    </Col>
                                </Form.Group>

                                <Form.Group className="mb-4" as={Row} controlId="formHorizontalFirstName">
                                    <Form.Label column sm={3}>
                                        Question
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control as="textarea" rows={3} type="text" placeholder="Enter faqs question" required value={states?.question || ""} name='question' onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">Please enter question.</Form.Control.Feedback>
                                    </Col>
                                </Form.Group>

                                <Form.Group className="mb-4" as={Row} controlId="formHorizontalLastName">
                                    <Form.Label column sm={3} >
                                        Answer
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control as="textarea" rows={5} type="text" placeholder="Enter faqs answer" required value={states?.answer || ""} name='answer' onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">Please enter faqs answer.</Form.Control.Feedback>
                                    </Col>
                                </Form.Group>

                                <Form.Group className="mb-4" as={Row} controlId="formHorizontalUsername">
                                    <Form.Label column sm={3}>
                                        Index
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="Enter Index" value={states?.index || ""} name='index' onChange={handleChange} />
                                    </Col>
                                </Form.Group>

                                <div className='d-flex justify-content-end'>
                                    <Button type='submit' className='m-0'>{Boolean(mode) ? "Save " : "Update "}</Button>
                                </div>

                            </Form>
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal>

            {/* Add &edit Modal */}
            <Modal
                show={viewModalShow}
                onHide={() => setViewModalShow(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <Card.Title as="h5">{"View "} {props?.title}</Card.Title>
                            <Modal.Header closeButton className='border-0'>
                            </Modal.Header>
                        </Card.Header>
                        <Card.Body>
                            {Boolean(subLoader) && <Loader loading={subLoader} />}
                            <div className="d-flex justify-content-between w-100 pl-4">
                                <table>
                                    <tr>
                                        <td>Page:</td>
                                        <td className="ps-3">
                                            {viewData?.page || "-"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Question:</td>
                                        <td className="ps-3">
                                            {viewData?.question || "-"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Answer:</td>
                                        <td className="ps-3">
                                            {viewData?.answer || "-"}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal>

            {/* Delete */}
            <Modal
                show={deleteModalShow}
                onHide={() => setDeleteModalShow(false)}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    {Boolean(subLoader) && <Loader loading={subLoader} />}
                    <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
                        <Card.Header className='d-flex justify-content-between align-items-center pe-0 pt-0 pb-0'>
                            <Card.Title as="h5">Delete {props?.title}</Card.Title>
                            <Modal.Header closeButton className='border-0'>
                            </Modal.Header>
                        </Card.Header>
                        <Card.Body className='pb-2'>
                            <h6>Are you sure you want to delete?</h6>
                            <div className='d-flex justify-content-center'>
                                <Button onClick={() => deleteFAQ()} className='mt-3 mb-0 mx-0'>Delete</Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default Faqs